export const getLastMonthString = (): string => {
  const date = new Date();
  let month = date.getMonth();
  let year = date.getFullYear();
  let dateString =
    year +
    '-' +
    month.toLocaleString('de-DE', {
      minimumIntegerDigits: 2,
      useGrouping: false,
    });
  return dateString;
};
